// src/Api/config.js
// API 配置文件和性能监控工具

const domainName = window.location.hostname;

// 根据环境设置不同的API地址
let normalServiceUrl = '';
let loginService = '';

if (domainName === "localhost" || domainName === "dev.zcloudapp.com") {
    // 开发环境：使用相对路径，通过代理转发到线上
    normalServiceUrl = "";
    loginService = "";
} else {
    // 生产环境：使用线上API
    normalServiceUrl = "https://chat.zhihua.chat";
    loginService = "https://chat.zhihua.chat";
}

// 开发环境配置
const DEV_CONFIG = {
  BASE_URL: normalServiceUrl,
  LOGIN_URL: loginService,
  API_PREFIX: '',
  TIMEOUT: 10000,
  TOKEN_KEY: 'token'
};

// 生产环境配置
const PROD_CONFIG = {
  BASE_URL: normalServiceUrl,
  LOGIN_URL: loginService,
  API_PREFIX: '',
  TIMEOUT: 10000,
  TOKEN_KEY: 'token'
};

// 根据环境选择配置
const isDevelopment = process.env.NODE_ENV === 'development';
export const API_CONFIG = isDevelopment ? DEV_CONFIG : PROD_CONFIG;

// 构建完整的 API URL
export const buildApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${API_CONFIG.API_PREFIX}${endpoint}`;
};

// Token 管理
export const getAuthToken = () => {
  return localStorage.getItem(API_CONFIG.TOKEN_KEY);
};

export const setAuthToken = (token) => {
  localStorage.setItem(API_CONFIG.TOKEN_KEY, token);
};

export const removeAuthToken = () => {
  localStorage.removeItem(API_CONFIG.TOKEN_KEY);
};

// 性能监控工具
class PerformanceMonitor {
  constructor() {
    this.apiCalls = [];
    this.cacheHits = 0;
    this.cacheMisses = 0;
  }

  // 记录API调用
  recordApiCall(apiName, startTime, endTime, cached = false) {
    const duration = endTime - startTime;
    this.apiCalls.push({
      apiName,
      duration,
      timestamp: new Date(),
      cached
    });
    
    if (cached) {
      this.cacheHits++;
    } else {
      this.cacheMisses++;
    }
  }

  // 获取性能统计
  getStats() {
    const totalCalls = this.apiCalls.length;
    const avgDuration = totalCalls > 0 
      ? this.apiCalls.reduce((sum, call) => sum + call.duration, 0) / totalCalls 
      : 0;
    
    const cacheHitRate = (this.cacheHits + this.cacheMisses) > 0 
      ? (this.cacheHits / (this.cacheHits + this.cacheMisses) * 100).toFixed(2)
      : 0;

    return {
      totalApiCalls: totalCalls,
      averageDuration: Math.round(avgDuration),
      cacheHitRate: `${cacheHitRate}%`,
      cacheHits: this.cacheHits,
      cacheMisses: this.cacheMisses
    };
  }

  // 打印性能报告
  printReport() {
    const stats = this.getStats();
  }

  // 重置统计
  reset() {
    this.apiCalls = [];
    this.cacheHits = 0;
    this.cacheMisses = 0;
  }
}

// 创建全局性能监控实例
export const performanceMonitor = new PerformanceMonitor();